module.exports = __webpack_public_path__ + "static/First_Data_Graphics_Reel-617d21209a93914d4634ee52b889d386.jpg";